import React, { useContext, useState } from "react";
import { InputAuto } from "../../../../../controls";
import { useEffect } from "react";
import { action, API, controller } from "../../../../../api/api";
import { AppContext } from "../../../../../App";
import { Dialog } from "../../../../../layout";
import AddEditAttr from "../../../ProdAttr/AddEditAttr";

const InputAttribute = ({ label, attr, setValues }) => {
  const { authUser } = useContext(AppContext);
  const [attrLabels, setAttrLabels] = useState([]);
  const [newAddingValue, setNewAddingValue] = useState("");
  const [showAttributForm, setShowAttributForm] = useState(false);

  useEffect(() => {
    // Get Variant Prod Attribute
    authUser &&
      API(controller.ProdAttr + action.GetAllByOrg).get((res) => {
        res.status === 200 &&
          setAttrLabels([...res.result.map((j) => ({ ...j, label: j.name }))]);
      });
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authUser]);

  const handleChgAttr = (e, id) => {
    var attrId = e.target.value;
    var attrDtl = attrLabels.find((j) => j.id === attrId);
    setValues((x) => ({
      ...x,
      prodVarAttrs: x.prodVarAttrs.map((j) =>
        j.id === id
          ? { ...j, attrId: e.target.value, name: attrDtl && attrDtl.label }
          : j
      ),
    }));
  };

  const handleAddNewAttr = (val) => {
    setNewAddingValue(val);
    setShowAttributForm(!showAttributForm);
  };

  const handleNewAttr = (val) => {
    if (val) {
      setAttrLabels([{ ...val, label: val.name }, ...attrLabels]);
      setValues((x) => ({
        ...x,
        prodVarAttrs: x.prodVarAttrs.map((j) =>
          j.id === attr.id ? { ...j, attrId: val.id, name: val.name } : j
        ),
      }));
      setNewAddingValue("");
    }
  };

  return (
    <>
      <InputAuto
        fullWidth
        label={label}
        name={`attr${attr.id}`}
        value={attr.attrId}
        onChange={(e) => handleChgAttr(e, attr.id)}
        options={attrLabels}
        enableAddBtn={true}
        handleAdd={handleAddNewAttr}
      />

      {/* Add new attribute */}
      {showAttributForm && (
        <Dialog show={showAttributForm} onClose={false} maxWidth="xs">
          <AddEditAttr
            {...{
              setShowForm: setShowAttributForm,
              openFromOtherSide: true,
              attrName: newAddingValue,
              handleResult: handleNewAttr,
            }}
          />
        </Dialog>
      )}
    </>
  );
};

export default InputAttribute;
